export default "__VITE_PUBLIC_ASSET__21de7c48__"